





import { Component, Vue, Prop, Watch } from 'vue-property-decorator';


@Component
export default class AccountAvatar extends Vue {
  @Prop({required: true}) private userDetailInfo!: IAuthenticate.IUserDetailInfo;
  private isSuccess = true;
  get avatarUrl() {
    return this.userDetailInfo.avatarUrl;
  }
  @Watch('avatarUrl')
  private watchAvatarUrl() {
    this.isSuccess = true;
  }
  private loadError() {
    this.isSuccess = false;
  }
}
